import React from "react";
import "./GenericHeader.css"; // Optional: Import CSS for styling
import { Globals } from "../../global/Globals";

const GenericHeader = ({
  title,
  onBack = null,
  onClose = null,
  backImgSrc = Globals.IMG.LEFT_ARROW,
  closeImgSrc = Globals.IMG.CLOSE,
}) => {
  return (
    <div className="generic-header">
      <div className="generic-header-content">
        {onBack && (
          <div className="generic-back">
            <img src={backImgSrc} alt="back" onClick={onBack} />
          </div>
        )}
        <label className="generic-header-title">{title}</label>
      </div>
      {onClose && (
        <div className="generic-close">
          <img
            className="generic-close-icon"
            src={closeImgSrc}
            alt="close"
            onClick={onClose}
          />
        </div>
      )}
    </div>
  );
};

export default GenericHeader;
